var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list.length > 0)?_c('b-button',{attrs:{"data-test-id":"button-export","variant":"light","size":"lg"},on:{"click":function($event){return _vm.jsonExport(_vm.list, _vm.type)}}},[_vm._v("\n  "+_vm._s(_vm.$t('label.export'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }